import { isValidLandingPageUrl } from '@provision/landing-page-utils';

/** Blank is allowed, so an image can be removed. */
export const IMAGE_URL_FIELD_RULES = {
  validate: (value: unknown) => {
    const url = String(value ?? '').trim();
    return !url || isValidLandingPageUrl(url) || 'Enter a valid URL (https://…)';
  },
};
